import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { DisplayToastAction } from 'src/app/core/actions/toast.actions';
import { CloseThread } from 'src/app/messagingV3/legacy/actions/message-ui.actions';
import * as fromSettings from '../../settings/reducers';
export var GLOBAL_CMS_ROUTE = 'content/global';
var NavigationService = /** @class */ (function () {
    function NavigationService(_router, _store) {
        var _this = this;
        this._router = _router;
        this._store = _store;
        this._store
            .pipe(select(fromSettings.getSectionTranslations('NavigationToast')))
            .subscribe(function (t) {
            _this._navigationToastText = t;
        });
    }
    NavigationService.prototype.navigate = function (commands, extras) {
        var targetUrl = this._router.serializeUrl(this._router.createUrlTree(commands, extras));
        if (this._bypassNavigationEvent(targetUrl)) {
            return;
        }
        if (this._router.url.toLowerCase().startsWith('/messages')) {
            this._store.dispatch(new CloseThread());
        }
        var nav = this._router.navigate(commands, extras);
        this._markNavigationInFlight(targetUrl, nav);
    };
    NavigationService.prototype.navigateAfterLogin = function (isGlobalPortal) {
        if (isGlobalPortal) {
            this.navigate(["/" + GLOBAL_CMS_ROUTE]);
        }
        else {
            this.navigate(['/']);
        }
    };
    NavigationService.prototype.navigateByUrl = function (url) {
        var targetUrl = this._router.serializeUrl(this._router.parseUrl(url));
        if (this._bypassNavigationEvent(targetUrl)) {
            return;
        }
        var nav = this._router.navigateByUrl(url);
        this._markNavigationInFlight(targetUrl, nav);
    };
    NavigationService.prototype._bypassNavigationEvent = function (targetUrl) {
        var last = this._lastNavigation;
        if (!last) {
            return false;
        }
        // If any navigation is currently in-flight, ignore further navigation attempts.
        // Rapid re-entrant navigations (even to different URLs) can wedge router state.
        var isDuplicate = last.inFlight;
        if (isDuplicate && last.url === targetUrl) {
            this._showAvoidDoubleClickToast();
        }
        return isDuplicate;
    };
    NavigationService.prototype._showAvoidDoubleClickToast = function () {
        var _a, _b;
        var title = ((_a = this._navigationToastText) === null || _a === void 0 ? void 0 : _a.Title) || 'Reminder';
        var message = ((_b = this._navigationToastText) === null || _b === void 0 ? void 0 : _b.AvoidDoubleClickMessage) ||
            'Please avoid double clicking or clicking too quickly on different links. Click once.';
        this._store.dispatch(new DisplayToastAction({
            type: 'info',
            title: title,
            message: message,
            timeout: 10000
        }));
    };
    NavigationService.prototype._markNavigationInFlight = function (targetUrl, navPromise) {
        var _this = this;
        this._lastNavigation = {
            url: targetUrl,
            timestamp: Date.now(),
            inFlight: true
        };
        navPromise.finally(function () {
            var _a;
            if (((_a = _this._lastNavigation) === null || _a === void 0 ? void 0 : _a.url) === targetUrl) {
                _this._lastNavigation = {
                    url: targetUrl,
                    timestamp: _this._lastNavigation.timestamp,
                    inFlight: false
                };
            }
        });
    };
    return NavigationService;
}());
export { NavigationService };
